import { queryClient } from "@/queryClient";
import { createFileRoute } from "@tanstack/react-router";
import { z } from "zod";

const gatewaysSearchSchema = z.object({
  configName: z.string().optional(),
});

export const Route = createFileRoute("/sources/edge-gateways/")({
  staticData: {
    title: "edge.navigation.edgeGateways",
  },
  loader: async () => {
    const { queries } = await import("@/modules/sources/edge-gateways/services/queries");
    return queryClient.ensureQueryData(queries.getGateways());
  },
  validateSearch: gatewaysSearchSchema,
});
